import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useVerificationDetails } from "../../../context/verification-details";
import { trackPageEvent } from "../../../utilities/trackPageEvent";
import {
  verificationCustomerStatus,
  verificationFormStatus,
} from "../../../constants/verification-status";

export const VerificationIFrame = ({
  customerStatus,
  externalCustomerVerificationUrl,
  sheerIdLocale,
}) => {
  const [state] = useVerificationDetails();
  const { externalFormVerificationUrl, formStatus } = state.verificationDetails;
  const [iframeHeight, setIframeHeight] = useState(500);
  const [iframeLocaleUrl, setIframeLocaleUrl] = useState();

  useEffect(() => {
    const iframeUrl = new URL(
      externalFormVerificationUrl || externalCustomerVerificationUrl
    );
    iframeUrl.searchParams.set("locale", sheerIdLocale);
    setIframeLocaleUrl(iframeUrl);
  }, [
    externalFormVerificationUrl,
    externalCustomerVerificationUrl,
    sheerIdLocale,
  ]);

  useEffect(() => {
    if (
      formStatus === verificationFormStatus.PENDING ||
      customerStatus === verificationCustomerStatus.PENDING_VERIFICATION
    ) {
      trackPageEvent({
        content: {
          layout: "student-verification-page-load",
          pageName: "further verifications",
        },
      });
      window.addEventListener("message", ({ data }) => {
        if (data?.action === "updateHeight") {
          setIframeHeight(data.height);
        }
      });
    }
  }, [formStatus, customerStatus]);

  return (
    <iframe
      src={iframeLocaleUrl}
      title="sheerID-verification-iframe"
      width="100%"
      height={iframeHeight}
    />
  );
};

VerificationIFrame.propTypes = {
  customerStatus: PropTypes.string,
  externalCustomerVerificationUrl: PropTypes.string,
  sheerIdLocale: PropTypes.string.isRequired,
};

VerificationIFrame.defaultProps = {
  externalCustomerVerificationUrl: null,
  customerStatus: null,
};
